export default __webpack_public_path__ + "static/media/brainwelness_icon_page.016c2ef7.svg";